<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-link
          style="font-size: 18px; color: #fff;"
          @click="checkTotal()"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80; font-size: 18px"> นับปริมาณจราจร </span>
          <br> {{ waydetail }}
        </b-link>&nbsp;&nbsp;
        <a
          :href="'https://drr-traffic-report.enixma.net/report_counting_view.php?wid=' + this.$route.query.wid"
          target="_blank"
        >
          <b-button
            size="sm"
            class="large-dropdown text-small"
            variant="outline-success"
          >
            <feather-icon
              icon="FileTextIcon"
              size="15"
            />
          </b-button>
        </a>
        <!-- <b-dropdown
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          split
          variant="outline-success"
          right
          class="large-dropdown text-small"
        >
          <template #button-content>
            <feather-icon
              icon="FileTextIcon"
              size="18"
            />
          </template>
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-traffic-report.enixma.net/report_counting_view.php?wid=' + this.$route.query.wid"
          >
            สรุปปริมาณนับรถ
          </b-dropdown-item>
          <b-dropdown-divider class="hidden" />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Hour.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถรายชั่วโมง
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถรายวัน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถรายเดือน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถ (PCU) รายวัน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถ (PCU) รายเดือน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถกราฟรายวัน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถกราฟรายเดือน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถกราฟ (PCU) รายวัน
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            target="_blank"
            :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
          >
            สรุปปริมาณรถกราฟ (PCU) รายเดือน
          </b-dropdown-item>
        </b-dropdown> -->
        &nbsp;
        <a :href="anydesk">
          <b-button
            size="sm"
            class="large-dropdown text-small"
            variant="outline-danger"
          ><b-img
            src="@/assets/images/logo/anydesk.png"
            style="height: 14px; width: 14px;"
          /></b-button>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BButton, BImg,
  // BDropdown, BDropdownItem, BDropdownDivider,
} from 'bootstrap-vue'
import axios from '@axios'
// eslint-disable-next-line import/no-unresolved

export default {
  components: {
    BImg,
    BLink,
    BButton,
    BRow,
    BCol,
    // BDropdown,
    // BDropdownItem,
    // BDropdownDivider,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      items: [],
      deptid: '',
      waydetail: '',
      anydesk: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getWayCount()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getWayCount()
    }, 300000)
  },
  methods: {
    checkTotal() {
      axios
        .post('/checkCountingTotal', { DeptID: this.deptid })
        .then(response => {
          if (response.data[0].count_deptid > 1 && this.deptid !== '0') {
            this.$router.push({ path: '/counting-sub', query: { DeptID: this.deptid } })
          } else if (this.deptid === '0') {
            this.$router.push({ path: '/' })
          } else {
            this.$router.push({ path: '/counting-total' })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getWayCount() {
      axios
        .post('/getWayCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style >
.large-dropdown .dropdown-menu {
  min-width: 100px; /* Adjust width as needed */
  font-size: 12px; /* Smaller font size */
  padding: 5px; /* Smaller padding */
}
.large-dropdown .btn {
  padding: 0.25rem 0.5rem; /* Smaller button padding */
  font-size: 0.875rem; /* Smaller text on the dropdown button */
}
.chart1{
  display: block;
  margin-left: auto;
  margin-right: auto;
    }
.hero::before {
    content: "";
    background: url(~@/assets/images/traffic/Jucntion.jpg) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 98%;
    height: 95%;
    opacity: 0.6;
  }
  .hero1::before {
    content: "";
    background: url(~@/assets/images/traffic/traffic3-1.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 95%;
    height: 90%;
    opacity: 0.6;
  }

</style>
